import { productionCategories } from "astrid-config/src/productionCategories/productionCategories";

import FirestoreDocument from "../../../types/FirestoreDocument";
import {
	array,
	boolean,
	enumArray,
	enumValues,
	int,
	language,
	nullable,
	object,
	record,
	ref,
	string,
	timestamp,
} from "../../../types/_types";

import articleTypes from "../../articles/constants/articleTypes";
import { ArticleContributor } from "../../articles/types/ArticleContributor";
import { ImprintRef } from "../../imprints/types/ImprintRef";
import { UserRef } from "../../users/types/User";
import { WorkRef } from "../../works/types/WorkRef";

import productionStatuses from "../constants/productionStatuses";
import productionTypes from "../constants/productionTypes";

export const productionType = nullable(enumValues(productionTypes));
export const productionStatus = enumValues(productionStatuses);
export const productionCategory = enumArray(productionCategories);

export const Production = FirestoreDocument.extend({
	deleted: boolean(),
	deletedBy: nullable(string()),
	created: nullable(timestamp()),
	createdBy: nullable(string()),
	updated: nullable(timestamp()),
	articleIds: array(string()),
	articles: record(
		string(),
		object({
			artifactIds: array(string()).optional(),
			type: nullable(enumValues(articleTypes)).optional(),
			deliveryDate: nullable(timestamp()).optional(),
		}),
	).default({}),
	category: nullable(productionCategory),
	contributors: array(ArticleContributor),
	deliveryDate: nullable(timestamp()),
	deliveryDuration: nullable(string()),
	imprint: nullable(ImprintRef),
	imgThumb: nullable(string()),
	isbns: array(string()),
	language: language(),
	pages: nullable(int()),
	part: nullable(int()),
	producer: string(),
	producerName: string(),
	productionDate: nullable(timestamp()),
	productionTags: array(string()),
	productionType: productionType,
	publisher: string(),
	publisherManagerIds: array(string()),
	publisherManagers: array(UserRef),
	publisherName: string(),
	script: nullable(string()),
	scriptDate: nullable(timestamp()),
	scriptUploadDate: nullable(timestamp()),
	series: nullable(string()),
	status: productionStatus.default(productionStatuses.DRAFT),
	tags: array(string()),
	title: string(1),
	voices: record(string(), object({ readerIds: array(string()) })).default({}),
	voiceNames: array(string()),
	work: nullable(WorkRef),
});

export const ProductionRef = ref(Production, {
	title: true,
	productionType: true,
});
